import { render, staticRenderFns } from "./DownloadData.vue?vue&type=template&id=9257818a&scoped=true&"
import script from "./DownloadData.vue?vue&type=script&lang=js&"
export * from "./DownloadData.vue?vue&type=script&lang=js&"
import style0 from "./DownloadData.vue?vue&type=style&index=0&id=9257818a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9257818a",
  null
  
)

export default component.exports